<div @fadein class="container">
  <ion-img src="assets/icon/logo.png"></ion-img>
</div>
